import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Category, Collection } from '../models';

@Injectable({
  providedIn: 'root',
})
export class SidenavStudioService {
  private _categories$ = new BehaviorSubject<Category[]>([]);
  private _collection$ = new BehaviorSubject<Collection[]>([]);
  private _categoriesSelected$ = new BehaviorSubject<number[]>([]);
  private _collectionsSelected$ = new BehaviorSubject<number[]>([]);
  private _coursesSelected$ = new BehaviorSubject<number[]>([]);

  public get categories$(): Observable<any> {
    return this._categories$.asObservable();
  }

  public get collection$(): Observable<any> {
    return this._collection$.asObservable();
  }

  public get categoriesSelected$(): Observable<any> {
    return this._categoriesSelected$.asObservable();
  }

  public get collectionsSelected$(): Observable<any> {
    return this._collectionsSelected$.asObservable();
  }

  public get coursesSelected$(): Observable<any> {
    return this._coursesSelected$.asObservable();
  }

  public passCategories(categories: any) {
    this._categories$.next(categories);
  }

  public passCategory(category: any) {
    this._categoriesSelected$.next(category);
  }

  public passCollection(collection: any) {
    this._collectionsSelected$.next(collection);
  }

  public passCourse(course: any) {
    this._coursesSelected$.next(course);
  }

  public editOrSaveCategory(category?) {
    const data = [...this._categories$.value];
    const existingCategoryIndex = !!category
      ? data.findIndex((cat) => cat.id === category.id || cat.id === null)
      : undefined;
    if (existingCategoryIndex !== -1) {
      if (data[existingCategoryIndex].id === null) data[existingCategoryIndex].id = category.id;
      data[existingCategoryIndex].nome = category.nome;
    } else {
      data.push({ ...category, numberCourses: 0 });
    }
    data.sort((a, b) => a.nome.localeCompare(b.nome));
    this._categories$.next(data);
  }

  public deleteCategory(categoryId?: number) {
    if (!categoryId) {
      this._categories$.next(this._categories$.value.filter((item) => !!item.id));
    }
    this._categories$.next(this._categories$.value.filter((item) => item.id !== categoryId));
  }

  public insertCollection(newCollection) {
    const categories = [...this._categories$.value];
    const categoryIndex = categories.findIndex((category) => category.id === newCollection.categoria_id);
    if (categoryIndex !== -1) {
      const collectionIndex = categories[categoryIndex].colecoes.findIndex(
        (collection) => collection.id === newCollection.id,
      );

      if (collectionIndex !== -1) {
        categories[categoryIndex].colecoes[collectionIndex] = newCollection;
      } else {
        categories[categoryIndex].colecoes.push(newCollection);
      }
      this._categories$.next(categories);
    }
  }

  public duplicateCourse(collection_id: number, old_course: any, params: any) {
    const categories = [...this._categories$.value];
    let collectionIndex = null;

    const categoryIndex = categories.findIndex((category) => {
      const aux = category.colecoes.findIndex((collection) => collection.id === collection_id);

      if (aux !== -1) {
        collectionIndex = aux;
        return true;
      }

      return false;
    });

    if (categoryIndex !== -1 && collectionIndex !== null) {
      const new_course = { ...old_course, id: params?.id, slug: params?.slug };
      categories[categoryIndex].colecoes[collectionIndex].cursos.push(new_course);
      this._categories$.next(categories);
    }
  }

  public editOrSaveCollection(collection) {
    const data = this._categories$.value;
    const category = data.find((cat) => cat.id === collection.categoria_id);
    if (!category) return;

    category.colecoes ??= [];

    const index = category.colecoes.findIndex((col) => col.id === collection.id || col.id === null);
    index !== -1 ? (category.colecoes[index] = collection) : category.colecoes.push(collection);

    this._categories$.next([...data]);
  }

  public deleteCollection(collection_id: number, category: any) {
    const newCategories = this._categories$.value.map((item) => {
      if (item.id === category.id) {
        return {
          ...item,
          colecoes: item.colecoes
            .filter((collection) => collection.id !== collection_id)
            .map((collection, index) => ({ ...collection, ordem: index + 1 })),
        };
      }
      return item;
    });

    this._categories$.next(newCategories);
  }
}
